import { selectFromRevokeServiceAccountDto } from '../../models';

export default selectFromRevokeServiceAccountDto()
  .revoked
  .toString();
